<template lang="pug">
.tab__content
  template(v-if="orders.length === 0")
    empty(@click="doAction('test0')", :title="`${$t('noUsedTickets')}`")
  template(v-else)
    template(v-for="order in orders")
      order(:order="order", :tab="'used'", @update="getOrders()")
      spacer(size="30px")
    .pag(v-if="lastPage && lastPage > 1")
      pagination(:current="page", :pages="lastPage", @load="toPage")
</template>

<script>
import Pagination from '@/components/Pagination';
import Order from '@/components/tickets/order';
import Empty from '@/components/tickets/empty';


import API from '@/api/api';

export default {
  name: '',
  components: {
    Order,
    Empty,
    Pagination,
  },
  props: {
    value: {
      type: String,
      default: '',
      required: false,
    },
  },
  data: () => ({
    orders: [],
    page: 1,
    lastPage: 1,
    loading: false,
  }),
  mounted() {
    global.console.log(this.$route.name);
    this.getOrders();
  },
  methods: {
    async getOrders() {
      this.loading = true;
      this.orders = [];
      const data = await API.getOrders({
        type: 'used',
        page: this.page,
        perPage: 5,
      });
      if (data && data.data) {
        this.orders = data.data;
        this.lastPage = data.last_page;
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    toPage(page) {
      this.page = page;
      this.orders = [];
      this.getOrders();
    },
    doAction() {},
  },
};
</script>

<style lang="scss"></style>
